export default __webpack_public_path__ + "static/media/mute.a0475083.png";